import React from 'react';

const Footer2 = () => (
  <div className="text-center border-t border-t-[#808080] p-[20px] text-[14px] leading-[16px]">
    <p className="mt-[15px]">
      All loans through LendingUSA are made by its
      {' '}
      <a href="https://lendingusa.com/lending-partners/" className="cursor-pointer text-[#0052CC]" target="_blank" rel="noreferrer">lending partners</a>
      . Minimum and maximum financed amounts vary by term and loan purpose. Loans are not available in all states. An origination fee of up to 8% may be included in the principal loan amount that may result in an APR of up to 29.99%.
    </p>
    <p className="mt-[15px]">
      <sup>1</sup>
      {' '}
      To check the rates you qualify for, LendingUSA does a soft credit pull that will not impact your credit score. However, if you choose to continue your application, your full credit report will be requested from one or more consumer reporting agencies, which is considered a hard credit pull.
    </p>
  </div>
);

export default Footer2;
